import { render, staticRenderFns } from "./addMainCategory.vue?vue&type=template&id=4c77702c"
import script from "./addMainCategory.vue?vue&type=script&lang=js"
export * from "./addMainCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports